import { type UserRole } from './buildUserRoles.js';

// The portfolio link preview / document title should reflect the same
// aggregated roles (services + projects) rendered on the page rather than the
// role baked into the API's urlMetaData, which can lag behind edits and surface
// roles the indy has already removed. Mirrors contra.com's
// `${displayName} - ${role} | Contra` format.
export const buildPortfolioMetaTitle = ({
  firstName,
  lastName,
  roles,
}: {
  firstName?: string | null;
  lastName?: string | null;
  roles: readonly UserRole[];
}): string | null => {
  const fullName = [firstName, lastName]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join(' ')
    .trim();

  const primaryRole = roles[0]?.name;

  if (!fullName || !primaryRole) {
    return null;
  }

  return `${fullName} - ${primaryRole} | Contra`;
};
